import React, { FC } from 'react';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { useDisputesContext } from '../../store/disputes/disputes-context';
import { useParams } from 'react-router-dom';
import { alertKount, alertMyRcvr, alertChargeblast } from '../../store/disputes/actions/disputes';
import { useFormik } from 'formik';
import {
    getAlertCountModalSchema,
    initialMatchDisputeModalValues, MATCH_DISPUTE_FORM_FIELD,
} from '../../constants/dispute/dispute-form';
import { FormInput } from '../merchants/FormInput';
import { InputType } from '../form/form-input-constants';
import { ITransactionsData } from '../../store/payments/payments-interfaces-helper';

interface IBody {
    disputeQueueItemId: string;
    transactionId: string;
    KountStatusCode?: string;
    statusCode?: string;
    Comments?: string;
}

interface Props {
    checkedItem: ITransactionsData;
    closeModal: () => void;
    matchSuccess: () => void;
    matchError: (error: any) => void;
    alertModalProvider: string;
}

export const AlertProviderModal: FC<Props> = (props) => {
    const { checkedItem, closeModal, matchSuccess, matchError, alertModalProvider } = props;
    const { disputeQueueItemId } = useParams<{ disputeQueueItemId: string }>();
    const { disputesContextState: { isKountAlertLoading, kountStatusCodes, disputeDetails }, dispatch } = useDisputesContext();

    const eventType = disputeDetails?.eventType ?? disputeDetails?.kountEventType;

    const formik = useFormik({
        initialValues: initialMatchDisputeModalValues,
        validationSchema: getAlertCountModalSchema,
        onSubmit: async (): Promise<void> => {
            if (!formik.isValid) return;

            const getValue = (fieldName: MATCH_DISPUTE_FORM_FIELD): string => {
                const formikValue = formik?.getFieldProps(fieldName);
                return formikValue?.value;
            };

            const body: IBody = {
                disputeQueueItemId,
                transactionId: checkedItem?.id,
                KountStatusCode: getValue(MATCH_DISPUTE_FORM_FIELD.STATUS_CODE)?.replace(' ', '_'),
            };

            if (getValue(MATCH_DISPUTE_FORM_FIELD.COMMENTS)) {
                body.Comments = getValue(MATCH_DISPUTE_FORM_FIELD.COMMENTS);
            }

            switch (alertModalProvider?.toLowerCase()) {
                case 'kount':
                    body.KountStatusCode = getValue(MATCH_DISPUTE_FORM_FIELD.STATUS_CODE)?.replace(' ', '_');
                    await alertKount(dispatch, body, matchSuccess, matchError);
                    break;
                case 'myrcvr':
                    body.statusCode = getValue(MATCH_DISPUTE_FORM_FIELD.STATUS_CODE)?.replace(' ', '_');
                    await alertMyRcvr(dispatch, body, matchSuccess, matchError);
                    break;
                case 'chargeblast':
                    body.statusCode = getValue(MATCH_DISPUTE_FORM_FIELD.STATUS_CODE)?.replace(' ', '_');
                    await alertChargeblast(dispatch, body, matchSuccess, matchError);
                    break;
                default:
                    break;
            }


        }
    });

    // const onMatchConfirm = async (): Promise<void> => {
    //     const getValue = (fieldName: MATCH_DISPUTE_FORM_FIELD): string => {
    //         const formikValue = formik?.getFieldProps(fieldName);
    //         return formikValue?.value;
    //     };
    //
    //     if (!formik.isValid) return;
    //
    //     const body: IBody = {
    //         disputeQueueItemId,
    //         transactionId: checkedItem?.id,
    //         KountStatusCode: getValue(MATCH_DISPUTE_FORM_FIELD.STATUS_CODE)?.replace(' ', '_'),
    //         Comments: getValue(MATCH_DISPUTE_FORM_FIELD.COMMENTS)
    //     };
    //
    //     await alertKount(dispatch, body, matchSuccess, matchError);
    // };


    const getPickerData = (): { value: string, label: string }[] => {
        if (eventType === 'ETHOCA_FRAUD') {
            return (kountStatusCodes?.ethocaFraud || [])?.map(el => ({
                value: el,
                label: el
            }));
        }

        if (eventType === 'ETHOCA_DISPUTE') {
            return (kountStatusCodes?.ethocaDispute || [])?.map(el => ({
                value: el,
                label: el
            }));
        }

        if (disputeDetails?.disputeManagementSystem === 'Chargeblast' && disputeDetails?.providerName === 'Ethoca') {
            return (kountStatusCodes?.chargeblastStatusCodes || [])?.map(el => ({
                value: el,
                label: el
            }));
        }

        if (eventType === 'RDR') {
            return Object.keys(kountStatusCodes?.verifyStatusCodes || {})?.map(el => ({
                value: el,
                label: `${el} - ${kountStatusCodes?.verifyStatusCodes?.[el]}`
            }));
        }

        return [];
    };

    return (
        <form onSubmit={formik.handleSubmit} className="pb-10">
            <div className="row px-8 mt-5">
                <FormInput
                    formik={formik}
                    key={MATCH_DISPUTE_FORM_FIELD.STATUS_CODE}
                    fieldName={MATCH_DISPUTE_FORM_FIELD.STATUS_CODE}
                    label={`${alertModalProvider} status code`}
                    placeholder={`${alertModalProvider} status code`}
                    required
                    inputType={InputType.Select}
                    data={getPickerData()}
                    searchable={false}
                    additionalClasses="col-sm-6 col-md-6"
                />
                <FormInput
                    formik={formik}
                    key={MATCH_DISPUTE_FORM_FIELD.COMMENTS}
                    fieldName={MATCH_DISPUTE_FORM_FIELD.COMMENTS}
                    label='Comments'
                    placeholder='Write comments'
                    inputType={InputType.Description}
                    additionalClasses="col-md-12"
                />
            </div>

            <div className="text-center mt-10">
                <ButtonComponent
                    buttonName="Cancel"
                    buttonType={BUTTON_TYPE.CANCELLED}
                    additionalClass="btn-sm"
                    onButtonClick={closeModal}
                />
                <ButtonComponent
                    buttonName="Alert"
                    additionalClass="btn-sm ms-10 w-100px"
                    type="submit"
                    loading={isKountAlertLoading}
                    isDisabled={isKountAlertLoading}
                />
            </div>
        </form>
    );
};
